import {
  CloneCreateResponse,
  CloneJobStatus,
  getLoadCloneJob,
} from 'lib/api/cloneLoads';
import { JobPollOptions, JobPollOutcome, pollJob } from 'utils/pollJob';

export type LoadClonePollOutcome = JobPollOutcome<CloneCreateResponse>;

type PollOptions = Omit<
  JobPollOptions<CloneCreateResponse>,
  'getJob' | 'isActive'
> & {
  getJob?: JobPollOptions<CloneCreateResponse>['getJob'];
};

export function pollLoadCloneJob(
  initialJob: CloneCreateResponse,
  { getJob = getLoadCloneJob, ...options }: PollOptions
): Promise<LoadClonePollOutcome> {
  return pollJob(initialJob, {
    ...options,
    getJob,
    isActive: isActiveCloneJob,
  });
}

export function isActiveCloneJob(job: CloneCreateResponse): boolean {
  return (
    job.status === CloneJobStatus.Pending ||
    job.status === CloneJobStatus.Processing
  );
}
